import {Component, OnInit} from '@angular/core';
import {SubscriptionPlanInfoResponse} from "../interface/subscriptionPlanInfoResponse";
import {SubscriptionPlanInfoService} from "../service/subscription-plan-info.service";
import {SubscriptionPlanInfoModel} from "../models/subscriptionPlanInfo.model";
import {SubscriptionType} from "../enums/subscription-type";
import {AccountType} from "../enums/account-type";
import {ToggleElModel} from "../layouts/toggle/toggle-el.model";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../models/language";

@Component({
  selector: 'app-subscription-plan',
  templateUrl: './subscription-plan.component.html',
  styleUrls: ['./subscription-plan.component.scss', './subscription-plan-media.component.scss']
})
export class SubscriptionPlanComponent implements OnInit {

  currentLang: string = '';

  protected isIndividuals: boolean = true;
  protected isYearly: boolean = false;

  protected individualsSubscriptionPlans: SubscriptionPlanInfoResponse[] = [];
  protected teamsSubscriptionPlans: SubscriptionPlanInfoResponse[] = [];

  protected subscriptionIndividualsPlanInfoModel: SubscriptionPlanInfoModel[] = [];
  protected subscriptionTeamsPlanInfoModel: SubscriptionPlanInfoModel[] = [];

  constructor(
    private subscriptionPlanDataService: SubscriptionPlanInfoService,
    public translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  ngOnInit() {
    this.subscriptionPlanDataService.findAll().subscribe(subscriptionPlans => {
      this.initializeSubscriptionPlans(subscriptionPlans);
    });
  }

  togglePlan(isIndividuals: boolean): void {
    this.isIndividuals = isIndividuals;
    this.updateSubscriptionModels();
  }

  toggleTerm(isYearly: boolean): void {
    this.isYearly = isYearly;
    this.updateSubscriptionModels();
  }

  initializeSubscriptionPlans(subscriptionPlans: SubscriptionPlanInfoResponse[]): void {
    this.individualsSubscriptionPlans = this.findByAccountType(subscriptionPlans, AccountType.INDIVIDUAL);
    this.teamsSubscriptionPlans = this.findByAccountType(subscriptionPlans, AccountType.TEAM);
    this.updateSubscriptionModels();
  }

  updateSubscriptionModels(): void {
    this.subscriptionIndividualsPlanInfoModel = this.individualsSubscriptionPlans.map(subscriptionPlan => new SubscriptionPlanInfoModel(
      subscriptionPlan,
      this.isIndividuals,
      this.isFirstPlan(subscriptionPlan.subscriptionType),
      this.isSecondPlan(subscriptionPlan.subscriptionType),
      this.isYearly
    ));

    this.subscriptionTeamsPlanInfoModel = this.teamsSubscriptionPlans.map(subscriptionPlan => new SubscriptionPlanInfoModel(
      subscriptionPlan,
      this.isIndividuals,
      this.isFirstPlan(subscriptionPlan.subscriptionType),
      this.isSecondPlan(subscriptionPlan.subscriptionType),
      this.isYearly
    ));
  }

  private isFirstPlan(subscriptionType: SubscriptionType): boolean {
    return subscriptionType === SubscriptionType.STARTER || subscriptionType === SubscriptionType.BASIC;
  }

  private isSecondPlan(subscriptionType: SubscriptionType): boolean {
    return subscriptionType === SubscriptionType.STANDARD || subscriptionType === SubscriptionType.PROFESSIONAL;
  }

  private findByAccountType(subscriptionPlans: SubscriptionPlanInfoResponse[], accountType: AccountType): SubscriptionPlanInfoResponse[] {
    return subscriptionPlans.filter(plan => {
      return plan.parent.accountType === accountType;
    });
  }

  protected readonly ToggleElModel = ToggleElModel;
  protected readonly Language = Language;
}
